<script setup>
import { useLocale } from '~/composables/useLocale'
import { useUiThemeStore } from '~/themes/useUiTheme'

useCatalogStore().ensureCatalog()

const { unavailable: serverUnavailable } = storeToRefs(useServerStore())
const { layout, ready } = storeToRefs(useUiThemeStore())
const { t, elementLocale } = useLocale()

onMounted(() => {
  if (serverUnavailable.value) {
    ElMessage.error({
      message: t('app.serverError'),
      duration: 6000,
      showClose: true,
    })
  }
})
</script>

<template>
  <el-config-provider :locale="elementLocale">
    <component :is="layout" v-if="layout">
      <router-view />
    </component>
    <div
      v-else-if="!ready"
      class="flex min-h-screen items-center justify-center bg-bg text-sm text-text-muted"
    >
      {{ t('app.loading') }}
    </div>
    <router-view v-else />
  </el-config-provider>
</template>
